import './tree-view.css';
export default {
  "dirRtl": "pf-v6-m-dir-rtl",
  "modifiers": {
    "compact": "pf-m-compact",
    "guides": "pf-m-guides",
    "expanded": "pf-m-expanded",
    "noBackground": "pf-m-no-background",
    "current": "pf-m-current",
    "truncate": "pf-m-truncate"
  },
  "treeView": "pf-v6-c-tree-view",
  "treeViewAction": "pf-v6-c-tree-view__action",
  "treeViewContent": "pf-v6-c-tree-view__content",
  "treeViewList": "pf-v6-c-tree-view__list",
  "treeViewListItem": "pf-v6-c-tree-view__list-item",
  "treeViewNode": "pf-v6-c-tree-view__node",
  "treeViewNodeCheck": "pf-v6-c-tree-view__node-check",
  "treeViewNodeContainer": "pf-v6-c-tree-view__node-container",
  "treeViewNodeContent": "pf-v6-c-tree-view__node-content",
  "treeViewNodeCount": "pf-v6-c-tree-view__node-count",
  "treeViewNodeIcon": "pf-v6-c-tree-view__node-icon",
  "treeViewNodeText": "pf-v6-c-tree-view__node-text",
  "treeViewNodeTitle": "pf-v6-c-tree-view__node-title",
  "treeViewNodeToggle": "pf-v6-c-tree-view__node-toggle",
  "treeViewNodeToggleIcon": "pf-v6-c-tree-view__node-toggle-icon",
  "treeViewSearch": "pf-v6-c-tree-view__search"
};